import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import { ThemeProvider } from './theme/theme-context';
import { GlobalStyles } from './theme/global-styles';
import { AccessibilityProvider } from './presentation/global/context/accessibility-context';
import { GlobalProvider } from './presentation/global/context/global-context';
import { AppInitializer } from './presentation/global/app-initializer';

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <BrowserRouter basename={(window as any).__BASENAME__ || '/'}>
      <ThemeProvider>
        <GlobalProvider>
          <AppInitializer>
            <AccessibilityProvider>
              <GlobalStyles />
              <App />
            </AccessibilityProvider>
          </AppInitializer>
        </GlobalProvider>
      </ThemeProvider>
    </BrowserRouter>
  </React.StrictMode>
);
